angular.module('umCore').constant('uiPerformanceLoggerConstant', {
    // CONSTANTS FOR THE UI PERFORMANCE LOGGER
    SUBMIT_SUBMISSION: 'submitSubmission',
    CLEAR_SUBMISSION: 'clearSubmission',
    CLEAR_READY_SUBMISSION: 'clearReadySubmission',
    DECLINE_SUBMISSION: 'declineSubmission',
    NEW_SUBMISSION: 'newSubmission',
    MAKE_SUBMISSION: 'makeSubmission',
    SHOW_FORM: 'showForm',
    GET_RATE: 'getRate',
    BEGIN_BINDING: 'beginBinding',
    BIND: 'bind',
    GENERATE_BINDER: 'generateBinder',
    LOGIN: 'login',
    LOGOUT: 'logout',
    SUBMISSION_HOME: 'submissionHome',
    TASK_HOME: 'taskHome',
    REQUEST_BINDING: 'requestBinding',
    DELETE_QUOTE: 'deleteQuote',
    COPY_QUOTE: 'copyQuote',
    COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL: 'copyQuoteForMultiQuoteProposal',
    CHANGE_PRODUCTS: 'changeProducts',
    UPDATE_STATUS_REASON: 'updateStatusReason',
    SEND_PROPOSAL: 'sendProposalToProducer',
    REFER_SUBMISSION: 'referSubmission',
    RETRACT_REFERRAL: 'retractReferral',
    BEGIN_ISSUANCE: 'beginIssuance',
    REVERT_TO_BOUND: 'revertToBound',
    SUBMIT_FOR_ISSUANCE: 'submitForIssuance',
    MODIFY_ISSUANCE: 'modifyIssuance',
    MARK_AS_ISSUED: 'markAsIssued',
    MARK_AS_LOST: 'markAsLost',
    MARK_EXPIRED: 'markExpired',
    MARK_RENEWED: 'markRenewed',
    MARK_NON_RENEWED: 'markNonRenewed',
    REVERT_TO_PENDING_ISSUANCE: 'revertToPendingIssuance',
    CLEAR_REFERRAL: 'clearReferral',
    DECLINE_REFERRAL: 'declineReferral',
    SPLIT_SUBMISSION: 'splitSubmission',
    START_POLICY_CANCELLATION: 'startPolicyCancellation',
    DELETE_DRAFT_CANCELLATION: 'deleteDraftCancellation',
    SUBMIT_FOR_CANCELLATION: 'submitForCancellation',
    MARK_AS_CANCELLED: 'markAsCancelled',
    REVERT_TO_CANCELLATION_PENDING: 'revertToCancellationPending',
    RESCIND_CANCELLATION: 'rescindCancellation',
    REQUEST_CANCELLATION: 'requestCancellation',
    RETRACT_CANCELLATION_REQUEST: 'retractCancellationRequest',
    RESUBMIT_SUBMISSION: 'resubmitSubmission',
    SUBMIT_RENEWAL: 'submitRenewal',
    SUBMIT_NON_RENEWAL: 'submitNonRenewal',
    RETRACT_NON_RENEWAL: 'retractNonRenewal',
    FLAG_FOR_NON_RENEWAL: 'flagForNonRenewal',
    CLEAR_NON_RENEWAL_FLAG: 'clearNonRenewalFlag',
    DISABLE_AUTOMATION: 'disableAutomation',
    CREATE_QUOTE: 'createQuote',
    POLICY_SUMMARY_GRID: 'policySummaryGrid',
    PROPOSAL_SUMMARY_GRID: 'proposalSummaryGrid',
    UNBIND: 'unbind',
    REINSTATE_POLICY: 'reinstatePolicy',
    MODIFY_BINDER: 'modifyBinder',
    ADD_SECTION: 'addSection',
    DELETE_SECTION: 'deleteSection',
    REVERT_TO_SENT: 'revertToSent',
    WITHDRAW_QUOTE: 'withdrawQuote',
    GENERATE_RATING_ATTACHMENTS: 'generateRatingAttachments',
    DELETE_ENDORSEMENT: 'deleteEndorsement',
    SUBMIT_ENDORSEMENT: 'submitEndorsement',
    MARK_ENDORSEMENT_AS_ISSUED: 'markEndorsementAsIssued',
    DECLINE_ENDORSEMENT: 'declineEndorsement',
    APPROVE_ENDORSEMENT: 'approveEndorsement',
    REVERT_TO_CLEAR: 'revertToClear',
    DELETE_USER: 'deleteUser',
    DEACTIVATE_USER: 'deactivateUser',
    ACTIVATE_USER: 'activateUser',
    RESET_PASSWORD: 'resetPassword',
    CREATE_PASSWORD: 'createPassword',
    UNLOCK_USER: 'unlockUser',
    RELOAD_FORM_RULES: 'reloadFormRules',
    RELOAD_FIELD_RULES: 'reloadFieldRules',
    RELOAD_SECTION_TEMPLATE_RULES: 'reloadSectionTemplateRules',
    DECLINE_TO_BIND: 'declineToBind',
    WITHDRAW_REQUEST: 'withdrawRequest',
    REDEPLOY_RULE_SETS: 'redeployRuleSets',
    UPDATE_PRODUCT_TEMPLATE: 'updateProductTemplate',
    CREATE_PRODUCT_TEMPLATE: 'createProductTemplate',
    DELETE_ORGANIZATION: 'deleteOrganization',
    DEACTIVATE_ORGANIZATION: 'deactivateOrganization',
    ACTIVATE_ORGANIZATION: 'activateOrganization',
    COPY_PROPOSAL: 'copyProposal',
    UPDATE_EMAIL_SIGNATURE: 'updateEmailSignature',
    UPDATE_PERMISSION: 'updatePermission',
    COPY_SUBMISSION: 'copySubmission',
    REWRITE_SUBMISSION: 'rewriteSubmission',
    ASSIGN_ACCOUNT_EXISTING: 'assignAccountExisting',
    ASSIGN_ACCOUNT_CREATE_NEW: 'assignAccountCreateNew',
    ASSIGN_ACCOUNT_SEARCH: 'assignAccountSearch',
    UPLOAD_ATTACHMENT: 'uploadAttachment',
    CREATE_ENDORSEMENT: 'createEndorsement',
    CREATE_PROPOSAL: 'createProposal',
    GENERATE_QUOTE: 'generateQuote',
    START_QUOTE: 'startQuote',
    SHOW_DOCUMENT: 'showDocument',
    CREATE_POLICY_REWRITE: 'createPolicyRewrite',
    DELETE_POLICY_REWRITE: 'deletePolicyRewrite',
    MARK_POLICY_REWRITE_AS_ISSUED: 'markPolicyRewriteAsIssued'
});
